import axios from "axios";
import { backend_url } from "../../utils/config.js";

const state = {
  notifications: [],
  count: 0,
};

const getters = {
  getNotifications: (state) => state.notifications,
  getNotificationsCount: (state) => state.count,
};

const actions = {
  NOTIFICATIONS_REQUEST: ({ commit }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`${backend_url}/notification`);
        commit("UPDATE_NOTIFICATIONS", data);
        resolve(data);
      } catch (err) {
        commit("NOTIFICATION_ERROR");
        reject(err);
      }
    });
  },
  UNREAD_NOTIFICATIONS_COUNT_REQUEST: ({ commit }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`${backend_url}/notification/count`);
        commit("UPDATE_NOTIFICATIONS_COUNT", data);
        resolve(data);
      } catch (err) {
        commit("NOTIFICATION_ERROR");
        reject(err);
      }
    });
  },
  DELETE_NOTIFICATION: ({ commit }, { _id }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.delete(
          `${backend_url}/notification/${_id}`
        );
        commit("DELETE_NOTIFICATION", data);
        resolve(data);
      } catch (err) {
        commit("NOTIFICATION_ERROR");
        reject(err);
      }
    });
  },
  UPDATE_NOTIFICATIONS: ({ commit }, notifications) => {
    return new Promise(async (resolve, reject) => {
      try {
        for (let i = 0; i < notifications.length; i++) {
          await axios.patch(
            `${backend_url}/notification/${notifications[i]._id}`
          );
          commit("UPDATE_NOTIFICATIONS_READ", notifications[i]);
        }
        commit("UPDATE_NOTIFICATIONS_COUNT", 0);
        resolve(0);
      } catch (err) {
        commit("NOTIFICATION_ERROR");
        reject(err);
      }
    });
  },
};

const mutations = {
  UPDATE_NOTIFICATIONS: (state, notifications) => {
    state.notifications = notifications;
  },
  UPDATE_NOTIFICATIONS_COUNT: (state, count) => {
    state.count = count;
  },
  DELETE_NOTIFICATION: (state, notification) => {
    state.notifications = state.notifications.filter(
      (notif) => notif._id !== notification._id
    );
  },
  UPDATE_NOTIFICATIONS_READ: (state, notification) => {
    state.notifications = state.notifications.map((notif) => {
      if (notif._id === notification._id) {
        return { ...notif, read: true };
      }

      return notif;
    });
  },
  NOTIFICATION_ERROR: (state) => {
    state.notifications = [];
    state.count = 0;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
